import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router';
import PageNotFound from '../../common/lib/PageNotFound';
import type { MultiLang } from '../../config';
import Functions from '../../functions';
import type CosmoDbContext from './CosmoDbContext';

interface Props {
    lang: MultiLang;
    context: CosmoDbContext;
    params: URLSearchParams;
}

const CosmoDbListViewSwitcher = (props: Props) => {
    const { lang, context, params } = props;
    const viewSwitcher: ReactNode[] = [];
    const paramId = params.get('id');
    if (paramId === null || !/^\d+$/.test(paramId)) {
        return <PageNotFound lang={lang} />;
    }
    const id = parseInt(paramId, 10);
    const lists = context.getLists();
    lists.forEach((value, index) => {
        const name = Functions.mlang(value.name, lang);
        if (index > 0) {
            viewSwitcher.push(<Fragment key={`${value.list_id}|`}> | </Fragment>);
        }
        if (value.list_id === id) {
            viewSwitcher.push(<span key={value.list_id}>{name}</span>);
        } else {
            const nParams = new URLSearchParams(params);
            nParams.set('id', value.list_id.toString());
            const url = context.getListUrl(nParams);
            viewSwitcher.push(
                <Link key={value.list_id} to={url}>
                    {name}
                </Link>
            );
        }
    });
    return <div className="view-switcher">{viewSwitcher}</div>;
};

export default CosmoDbListViewSwitcher;
